module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gal_layer_off-ff9615891661328ed962360abe3cc2eb.png";